<div
  class="spotlight-section-wrap"
  [ngClass]="{
    tablet: globalUtilsService.isTablet(),
    mobile: globalUtilsService.isMobile()
  }"
>
  <!-- <app-background-images
    style="display: block; width: 100%; height: 100%;"
  ></app-background-images> -->
  <!-- <div class="bg" style="background: black; display: block; position: absolute; left: 0; right: 0; top: 0; bottom: 0;"> -->
    <!-- <div style="opacity: 0.4; display: block; background-size: cover; position: absolute; left: 0; right: 0; top: 0; bottom: 0;"></div> -->
    <!-- <img width="100%" height="100%" style="display: block; position: absolute; left: 0; right: 0; top: 0; bottom: 0;" src="assets/images/background/f_desktop.jpg" /> -->
  <!-- </div> -->
   <div class="bg" [ngStyle]="getBackgroundStyle()"></div>

  <div class="spotlight-content">
    <app-logo></app-logo>
    <app-big-title></app-big-title>
    <app-contact-block
      *ngIf="globalUtilsService.isDesktop()"
    ></app-contact-block>
  </div>
  <app-vertical-copyright
    *ngIf="globalUtilsService.isDesktop()"
  ></app-vertical-copyright>
</div>
